import { gql } from '@apollo/client';

const PriceBookProductInfoPublic = gql`
  fragment PriceBookProductInfoPublic on PriceBookProduct {
    id
    price
    showInStore
    overPrice
    productId
    product {
      id
      name
      price
      description
      description
      sku
      defaultSubscriptionRetainer
      productCategories {
        id
        name
      }
      featuredImage
      productRenewalInterval {
        id
        name
      }
      productFeatures {
        id
        text
      }
      productImages {
        id
        imageUrl
      }
      productType
      planSubscription {
        id
        name
      }
      planProducts {
        id
        overridePrice
        price
      }
    }
  }
`;

export default PriceBookProductInfoPublic;
